import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRadioSelectedDisabled = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 25 25",
	fill: "var(--control-disabled-bg, #E8EAEB)",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 1,
		y: 1,
		width: 23,
		height: 23,
		rx: "var(--radio-radius, 7.5)",
		fill: "var(--control-disabled-bg, #E8EAEB)",
		stroke: "var(--control-disabled-border, #CFD4D5)",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 5.5,
		y: 5.5,
		width: 14,
		height: 14,
		rx: "var(--radio-dot-radius, 4)",
		fill: "var(--control-disabled-selected-bg, #E8EAEB)"
	})]
});
export default SvgRadioSelectedDisabled;
